export const BLOG_SUBSCRIPTION_FORM_TITLE = "Subscribe to our blog updates"
export const BLOG_SUBSCRIPTION_FORM_SUBTITLE =
  "Receive a weekly digest of new blog posts"
